import { render, staticRenderFns } from "./CartPromos.vue?vue&type=template&id=9035daea"
import script from "./CartPromos.ts?vue&type=script&lang=ts&external"
export * from "./CartPromos.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports